import { Modal } from "@components/ModalV2";
import { Button } from "@components/Button";
import { setStorefront } from "@hooks/index";
import modalStyles from "./setRegionModal.module.css";
import { useRouter } from "next/router";

export function SetRegionModal({ isShown, setToggle }) {
  const router = useRouter();
  const { pathname, query, asPath } = router;

  const handleSetRegion = (store) => {
    setStorefront(store);
    if (store === 'kotn-uk') {
      router.push({ pathname, query }, asPath, { locale: 'gb' });
    }
    else {
      setToggle(false);
    }

  };

  return (
    <Modal isShown={isShown} hide={setToggle} ariaLabel="regionModalId">
      <div className={modalStyles.modalContainer}>
        <h2 className={modalStyles.title}>Set Your Region</h2>
        <p className={modalStyles.description}>
          It Looks like you are shopping with us from the United Kingdom. Please select to confirm your location below to continue shopping on Kotn!
        </p>
        <Button
          variant="primary"
          handleClick={() => handleSetRegion('kotn-uk')}
          description="setRegion"
          descriptionText="Fetch more customer reviews"
          full
        >
          I'm in the UK
        </Button>

        <div className={modalStyles.spacer}></div>

        <Button
          variant="secondary"
          handleClick={() => handleSetRegion('kotn-ss15')}
          description="setRegion"
          descriptionText="Fetch more customer reviews"
          full
        >
          I'm outside the UK
        </Button>
      </div>
    </Modal>
  );
} 